import { Label } from "common/common.styled";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const StyledLabel = styled(Label)`
    align-self: flex-end;
    width: 40px;
    height: 40px;
    position: relative;

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const Table = styled.table`
    border-collapse: collapse;
    width: 600px;
    margin: 3rem 0;
    font-size: 14px;
    border: 1px solid #f2f2f2;
`;

export const THead = styled.thead`
    border: 1px solid #f2f2f2;
`;

export const TBody = styled.tbody`
    tr {
        &:not(:last-child) {
            border-bottom: 1px solid #f2f2f2;
        }
    }
`;

export const Th = styled.th`
    text-align: left;
    padding: 8px 10px;
    color: #1f1f1f;
    background-color: #f9f9f9;
`;

export const Tr = styled.tr``;

export const Td = styled.td<{ align?: string }>`
    padding: 11px 10px;
    text-align: ${({ align }) => align || "left"};
    color: #909090;
    svg {
        cursor: pointer;
        margin-right: 0.5rem;
        font-size: 18px;
    }
`;

export const MobileExpWrapper = styled.div`
    display: flex;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    border-radius: 12px;
    border: 1px solid #efedf2;
    width: fit-content;
    margin-top: 10px;
    flex-wrap: wrap;
`;

export const GreyText = styled(Text)`
    font-style: italic;
    font-weight: 600;
    color: #909090;
`;

export const ExpTitle = styled(GreyText)`
    font-style: normal;
`;

export const ExpRole = styled(ExpTitle)`
    color: #bdbdbd;
`;

export const ButtonContainer = styled.div`
    height: fit-content;
    margin-top: auto;
    display: flex;
    gap: 5px;
    padding-top: 10px;

    @media (${theme.breakpoints.mobileL}) {
        gap: 20px;
        svg {
            transform: scale(1.2);
        }
    }
`;
